import React from 'react';
import withLocale from './withLocale';
import { replaceStrings } from './replace-strings';

/**
 * Create a new component that inspects all string properties
 * and attempts to find them in the locale string data,
 * replacing them with the actual string values if present.
 */
export function withTextForward(Component) {
  function ComponentWithStrings({ locale, dispatch, ...restProps }) {
    const updatedData = replaceStrings(locale, restProps, true);
    return <Component {...updatedData} />;
  }

  return withLocale(ComponentWithStrings);
}
